import { ErrorMessages } from '../constants/ErrorMessages'

export const getErrorMessage = function (error) {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message
  }
  return ErrorMessages.COMMON_ERROR_MESSAGE
}
